import React from 'react'
import '../App.css'
import { Badge } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export class Bodyheaderlogin extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className='sshbodyappContainerRegister'>
                <div className='container'>
                    <div className="row">
                        <div className="col col-lg-7">
                            
                        </div>
                        <div className="col col-lg-5">
                            <h5>
                                Ya está registrado? <Link to={'/'}><Badge bg="secondary">Ingresar</Badge></Link>
                            </h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}